import React from 'react';
import './QuickReplyButtons.css';

const QuickReplyButtons = ({ suggestions = [], onSuggestionClick, disabled = false }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const handleSuggestionClick = (suggestion) => {
    if (!disabled && onSuggestionClick) {
      onSuggestionClick(suggestion);
    }
  };

  return (
    <div className="quick-reply-container">
      <div className="quick-reply-label">
        Suggested questions:
      </div>
      <div className="quick-reply-buttons">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className={`quick-reply-button ${disabled ? 'disabled' : ''}`}
            onClick={() => handleSuggestionClick(suggestion)}
            disabled={disabled}
            type="button"
          >
            <span className="button-text">{suggestion}</span>
            <svg 
              className="button-icon" 
              viewBox="0 0 16 16" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M6 12L10 8L6 4" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickReplyButtons;